import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { HelpCircle, ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Sirve si uso Tango, Holistor u otro sistema contable?',
  a: 'Sí. El Megapack no reemplaza tu sistema contable, lo potencia. Los prompts funcionan con cualquier sistema porque trabajan sobre los archivos exportados (XLS, CSV, PDF). Tu sistema actual no cambia, tu eficiencia sobre él sí.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Inmediatamente después del pago recibís un mail con el link de descarga de los 6 tomos en PDF y todos los bonos. El acceso es en menos de 5 minutos. Sin esperas. Sin envíos físicos.'
}, {
  q: '¿Qué lo diferencia de los cursos de IA genéricos?',
  a: 'Los cursos de IA genéricos te enseñan a usar ChatGPT en abstracto. Este Megapack está construido 100% sobre la realidad del contador argentino: ARCA, IVA, Ganancias, Ingresos Brutos, monotributo, sistema bimonetario, inflación. Cada prompt fue diseñado para este contexto específico. No hay nada que adaptar.'
}, {
  q: '¿Necesito saber programar para usar las macros?',
  a: 'No. Las macros vienen con el código VBA listo para copiar y pegar, y con instrucciones de instalación paso a paso de 5 pasos. Si sabés abrir Excel, podés instalar una macro en 3 minutos.'
}, {
  q: '¿Funciona para estudios unipersonales o solo para estudios grandes?',
  a: 'Está diseñado específicamente para el contador independiente y el estudio unipersonal. De hecho, el impacto es mayor en estudios pequeños porque la eficiencia se nota inmediatamente cuando sos vos quien hace todo.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 45 días. Sin preguntas. Si no es lo que esperabas, devolvemos el 100% del dinero. Podés escribirnos a hola@librofy.store y el reembolso se procesa en 48 horas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-brand-darker border-y border-slate-800/50" data-id="element-94">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-95">
        <FadeIn className="text-center mb-12" data-id="element-96">
          <HelpCircle className="w-12 h-12 text-brand-accent mx-auto mb-4" data-id="element-97" />
          <h2 className="text-3xl font-bold" data-id="element-98">❓ LO QUE MÁS NOS PREGUNTAN</h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-99">
          {faqs.map((faq, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-100">
              <div className={`bg-brand-card border ${openIndex === i ? 'border-brand-accent/50' : 'border-slate-800'} rounded-xl overflow-hidden transition-colors`} data-id="element-101">
                <button className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-102">
                  <span className="font-bold text-white pr-8" data-id="element-103">{faq.q}</span>
                  <ChevronDown className={`w-5 h-5 text-brand-accent shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-104" />
                </button>

                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === i ? 'max-h-96 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-105">
                  <p className="text-slate-300 leading-relaxed" data-id="element-106">{faq.a}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}